import styled from 'styled-components';

import { CUST, CUST_ANIM } from '../../../../theme/customizer-tokens';

/** Centered arrow row that sits directly beneath a suggestions list. */
export const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding-top: 4px;
`;

/** Circular ghost chevron button — neutral by default, lifts on hover, dims when
 *  it can't move (start / end of the revealed history). */
export const NavBtn = styled.button`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 999px;
  border: 1px solid ${CUST.panelBorder};
  background: transparent;
  color: ${CUST.textMuted};
  cursor: pointer;
  transition: color ${CUST_ANIM.INTERACT_MS}ms ease, border-color ${CUST_ANIM.INTERACT_MS}ms ease,
    background ${CUST_ANIM.INTERACT_MS}ms ease;

  &:hover:not(:disabled) {
    color: ${CUST.white};
    border-color: ${CUST.cardBorder};
    background: ${CUST.headerAvatarBg};
  }

  &:disabled {
    opacity: 0.35;
    cursor: default;
  }
`;
